import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Ticker from "@/components/sections/Ticker";
import FeaturedOn from "@/components/sections/FeaturedOn";
import Mission from "@/components/sections/Mission";
import WhyThisMatters from "@/components/sections/WhyThisMatters";
import Founder from "@/components/sections/Founder";
import ImpactStats from "@/components/sections/ImpactStats";
import TransparencyTeaser from "@/components/sections/TransparencyTeaser";
import Tokenomics from "@/components/sections/Tokenomics";
import PriceTracker from "@/components/sections/PriceTracker";
import HowToBuy from "@/components/sections/HowToBuy";
import Roadmap from "@/components/sections/Roadmap";
import FAQ from "@/components/sections/FAQ";
import Regrowth from "@/components/sections/Regrowth";
import Presale from "@/components/sections/Presale";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <main className="bg-background text-foreground overflow-x-hidden" data-testid="home-page">
      <Navbar />
      <Hero />
      <Ticker />
      <FeaturedOn />
      <Mission />
      <WhyThisMatters />
      <Founder />
      <ImpactStats />
      <TransparencyTeaser />
      <Tokenomics />
      <PriceTracker />
      <HowToBuy />
      <Roadmap />
      <FAQ />
      <Regrowth />
      <Presale />
      <Footer />
    </main>
  );
}
